import { ErrorPageBase } from '@/pages/ErrorPage';

export default function NotFoundPage() {
  return (
    <ErrorPageBase
      code={404}
      title="Oops! Page not found"
      description={"The page you're looking for doesn't exist or has been moved."}
      action={{ label: 'Go back home', to: '/' }}
    />
  );
}
